import { createContext, useContext, useState } from 'react';
import type { Dispatch, PropsWithChildren, ReactNode, SetStateAction } from 'react';

type PaymentMethodsContextType = {
  onSubmit?: () => void;
  setOnSubmit: Dispatch<SetStateAction<(() => void) | undefined>>;
};
const PaymentMethodsContext = createContext<PaymentMethodsContextType | null>(null);

const PaymentMethodsProvider = ({ children }: PropsWithChildren<ReactNode>) => {
  const [onSubmit, setOnSubmit] = useState<() => void>();

  return (
    <PaymentMethodsContext.Provider value={{ onSubmit, setOnSubmit }}>
      {children}
    </PaymentMethodsContext.Provider>
  );
};

export const usePaymentMethod = () => {
  const context = useContext(PaymentMethodsContext);
  if (!context) {
    throw new Error('usePaymentMethod must be used within a PaymentMethodsProvider');
  }
  return context;
};

export default PaymentMethodsProvider;
